import { Link } from "react-router-dom";

export default function Impressum() {
  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #0f0c29, #302b63, #24243e)",
      color: "#e2e8f0",
      fontFamily: "'Figtree', sans-serif",
      padding: "2rem 1rem",
    }}>
      <div style={{
        maxWidth: "800px",
        margin: "0 auto",
        background: "rgba(255,255,255,0.05)",
        backdropFilter: "blur(16px)",
        borderRadius: "1.5rem",
        border: "1px solid rgba(255,255,255,0.1)",
        padding: "3rem",
      }}>
        {/* Header */}
        <Link to="/" style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "0.5rem",
          color: "#a78bfa",
          textDecoration: "none",
          marginBottom: "2rem",
          fontSize: "0.9rem",
          fontWeight: 500,
        }}>
          ← Zurück zur Startseite
        </Link>

        <h1 style={{
          fontSize: "2.5rem",
          fontWeight: 800,
          background: "linear-gradient(135deg, #a78bfa, #60a5fa)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          marginBottom: "0.5rem",
        }}>Impressum</h1>
        <p style={{ color: "#94a3b8", marginBottom: "2.5rem", fontSize: "0.9rem" }}>
          Angaben gemäß § 5 TMG
        </p>

        <Section title="Betreiber">
          <p>Jan-Lukas Ewerling</p>
          <p>Schillerstraße 45</p>
          <p>66571 Dirmingen</p>
          <p>Deutschland</p>
        </Section>

        <Section title="Kontakt">
          <p>E-Mail: <a href="mailto:kontakt@kaidra.app" style={{ color: "#a78bfa" }}>kontakt@kaidra.app</a></p>
          <p>Website: <a href="https://www.kaidra.app" target="_blank" rel="noopener noreferrer" style={{ color: "#a78bfa" }}>www.kaidra.app</a></p>
        </Section>

        <Section title="Verantwortlich für den Inhalt (§ 18 Abs. 2 MStV)">
          <p>Jan-Lukas Ewerling</p>
          <p>Schillerstraße 45</p>
          <p>66571 Dirmingen</p>
        </Section>

        <Section title="Haftung für Inhalte">
          <p style={{ lineHeight: 1.8, color: "#94a3b8" }}>
            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten
            nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
            Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
            Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
            Tätigkeit hinweisen.
          </p>
        </Section>

        <Section title="Haftung für Links">
          <p style={{ lineHeight: 1.8, color: "#94a3b8" }}>
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
            Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
            Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
            Seiten verantwortlich.
          </p>
        </Section>

        <Section title="Urheberrecht">
          <p style={{ lineHeight: 1.8, color: "#94a3b8" }}>
            Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen
            dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art
            der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen
            Zustimmung des jeweiligen Autors bzw. Erstellers.
          </p>
        </Section>

        <Section title="Streitschlichtung">
          <p style={{ lineHeight: 1.8, color: "#94a3b8" }}>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
            <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" style={{ color: "#a78bfa" }}>
              https://ec.europa.eu/consumers/odr/
            </a>.
            Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind nicht bereit oder
            verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
            teilzunehmen.
          </p>
        </Section>

        <div style={{ marginTop: "3rem", paddingTop: "2rem", borderTop: "1px solid rgba(255,255,255,0.1)", display: "flex", gap: "2rem" }}>
          <Link to="/datenschutz" style={{ color: "#a78bfa", textDecoration: "none", fontSize: "0.9rem" }}>Datenschutzerklärung</Link>
          <Link to="/" style={{ color: "#a78bfa", textDecoration: "none", fontSize: "0.9rem" }}>Startseite</Link>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: "2rem" }}>
      <h2 style={{
        fontSize: "1.2rem",
        fontWeight: 700,
        color: "#e2e8f0",
        marginBottom: "0.75rem",
        paddingBottom: "0.5rem",
        borderBottom: "1px solid rgba(167,139,250,0.3)",
      }}>{title}</h2>
      <div style={{ color: "#cbd5e1", lineHeight: 1.8 }}>{children}</div>
    </div>
  );
}
